import { create } from 'zustand';

/** Fleet selection, shared by the Fleet grid, Maps (send robots) and the Agent (default targets). */
interface SelectionState {
  selected: string[];
  toggle: (serial: string) => void;
  set: (serials: string[]) => void;
  clear: () => void;
}

export const useSelection = create<SelectionState>((set, get) => ({
  selected: [],
  toggle: (serial) => {
    const cur = get().selected;
    set({ selected: cur.includes(serial) ? cur.filter((s) => s !== serial) : [...cur, serial] });
  },
  set: (selected) => set({ selected }),
  clear: () => set({ selected: [] }),
}));

const FOCUS_KEY = 'cruzr.focus';
export function rememberFocus(serial: string) {
  try {
    localStorage.setItem(FOCUS_KEY, serial);
  } catch {
    /* ignore */
  }
}
export function lastFocus(): string | null {
  try {
    return localStorage.getItem(FOCUS_KEY);
  } catch {
    return null;
  }
}
